export default {
  apiPath: '/cms',
  defaultPath: '/campaigns' // default application route
};
